import { FrameName } from "../config";
import TileEntity from "../TileEntity";

type RiverFrameNames =
	| FrameName.RIVER10
	| FrameName.RIVER5
	| FrameName.RIVER12
	| FrameName.RIVER9
	| FrameName.RIVER3
	| FrameName.RIVER6
	| FrameName.RIVER14
	| FrameName.RIVER13
	| FrameName.RIVER11
	| FrameName.RIVER7
	| FrameName.RIVER15;
// | FrameName.RIVER_SPRING2
// | FrameName.RIVER_SPRING4
// | FrameName.RIVER_SPRING8
// | FrameName.RIVER_SPRING1
// | FrameName.RIVER_DELTA2
// | FrameName.RIVER_DELTA4
// | FrameName.RIVER_DELTA8
// | FrameName.RIVER_DELTA1;

abstract class AbstractRiverTerrainTileEntity extends TileEntity {
	public static readonly frameName: RiverFrameNames = FrameName.RIVER10;

	// public get upgrades(): Map<FrameName, UpgradeParams> {
	// 	const upgrades = new Map<FrameName, UpgradeParams>(
	// 		super.config.upgrades,
	// 	);

	// Toto sa nakoniec nepouzilo, nechavam to tu ako referenciu pre ine upgrady.
	// 	if (useUpgradesStore().getCurrentLevelById(UpgradeIds.__TODO__) > 0) {
	// 		upgrades.set(FrameName.DARKWOOD_LUMBER_MILL, {
	// 			// Budova ide zo storage.
	// 		});
	// 	}

	// 	return upgrades;
	// }
}

export default AbstractRiverTerrainTileEntity;
